"use client";

import { UserCheck, UserPlus } from "lucide-react";

import { FIELD_CLASSNAME } from "@/src/components/online-scheduling/types";
import { Label } from "@/src/components/shadcn/ui/label";
import { Textarea } from "@/src/components/shadcn/ui/textarea";
import { ToggleGroup, ToggleGroupItem } from "@/src/components/shadcn/ui/toggle-group";
import { Muted } from "@/src/components/typography";
import { cn } from "@/src/lib/shadcn-utils";

const OPTION_CLASSNAME = cn(FIELD_CLASSNAME, "h-auto w-full justify-start gap-2 px-4 py-4");

export function VisitStep({
  isReturningPatient,
  onChangeReturning,
  reasonForVisit,
  onChangeReason,
  brandName,
}: {
  isReturningPatient: boolean;
  onChangeReturning: (isReturning: boolean) => void;
  reasonForVisit: string;
  onChangeReason: (reason: string) => void;
  brandName?: string;
}) {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label id="patient-type-label">Have you visited {brandName ?? "us"} before?</Label>
        <ToggleGroup
          type="single"
          variant="outline"
          aria-labelledby="patient-type-label"
          value={isReturningPatient ? "returning" : "new"}
          onValueChange={(value) => {
            if (value) {
              onChangeReturning(value === "returning");
            }
          }}
          className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2"
        >
          <ToggleGroupItem value="new" className={OPTION_CLASSNAME}>
            <UserPlus />
            I&apos;m a new patient
          </ToggleGroupItem>
          <ToggleGroupItem value="returning" className={OPTION_CLASSNAME}>
            <UserCheck />
            I&apos;m a returning patient
          </ToggleGroupItem>
        </ToggleGroup>
      </div>

      <div className="space-y-2">
        <Label htmlFor="reason-for-visit">
          What brings you in? <span className="font-normal text-muted-foreground">(optional)</span>
        </Label>
        <Textarea
          id="reason-for-visit"
          value={reasonForVisit}
          onChange={(event) => onChangeReason(event.target.value)}
          placeholder="Briefly describe the reason for your visit…"
          rows={3}
          maxLength={200}
          className={FIELD_CLASSNAME}
        />
      </div>

      <Muted className="block">For a medical emergency, call 911.</Muted>
    </div>
  );
}
